import { createContext, useContext, useCallback } from 'react';
import zh from './zh';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // 全站只用中文：lang 固定 zh，无语言切换。
  const lang = 'zh';

  const t = useCallback((key, params = {}) => {
    const keys = key.split('.');
    let val = zh;
    for (const k of keys) {
      val = val?.[k];
    }
    if (typeof val === 'string') {
      return val.replace(/\{(\w+)\}/g, (match, paramKey) => (
        Object.prototype.hasOwnProperty.call(params, paramKey) ? params[paramKey] : match
      ));
    }
    return val || key;
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
